import { useTranslation } from "react-i18next";
import "../../css/Authentication/Authentication.css";
import { UploadImageOperation } from "./AuthenticationRequest";
import { useContext, useState } from "react";
import { AuthContext } from "../SessionChecker/SessionChecker";

function Authentication({ theme }) {
  const { t } = useTranslation();

  const { authenticationImage, setAuthenticationImage, authenticationStatus } =
    useContext(AuthContext);

  const [requestStatus, setRequestStatus] = useState(false);

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>
        {t("Authentication")}
      </div>

      <div className="contentDiv padding12">
        {authenticationStatus ? (
          <div>{t('Ok')}</div>
        ) : !authenticationImage ? (
          <div className="uploadImageDiv">
            <img src="/images/authentication.jpg"></img>
            <button
              className="submit_button"
              onClick={() => {
                UploadImageOperation(setAuthenticationImage, setRequestStatus);
              }}
            >
              {requestStatus ? (
                <img src="/icons/loading.png" className={`icon rotate`}></img>
              ) : (
                t("Upload image")
              )}
            </button>
          </div>
        ) : (
          <div className="underReviewDiv">{t("Under Review")}</div>
        )}
      </div>
    </div>
  );
}

export default Authentication;
